module.exports = __webpack_public_path__ + "02ba470750f648ae583e10dd31cc22bd.pdf";